import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import {addUnit} from '../../common/utils/format';

var _createNamespace = createNamespace('cell-group'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('CellGroup'),
    data: function data() {
        return {};
    },
    props: {
        title: [String, Number],
        titleSize: [String, Number],
        titleColor: String,
        groupClass: String
    },
    render: function render() {
        var h = arguments[0];
        var title = this.title,
            titleSize = this.titleSize,
            titleColor = this.titleColor,
            groupClass = this.groupClass;
        var classes = [b()];
        var titleStyle = {};
        groupClass && classes.push(groupClass);
        titleSize && (titleStyle['fontSize'] = addUnit(titleSize));
        titleColor && (titleStyle['color'] = titleColor);
        return h(
            'div',
            {
                class: classes
            },
            [
                title
                    ? h(
                          'div',
                          {
                              class: b('title'),
                              style: titleStyle
                          },
                          [title]
                      )
                    : '',
                this.$slots.default && this.$slots.default
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
